import React from 'react';

const { Provider, Consumer } = React.createContext(false);

export const DisableProvider = ({ disabled, children }) => (
    <Provider value={!!disabled}>{children}</Provider>
);

const runWhen = bool => fn => (!(bool && fn) ? undefined : (...args) => fn(...args));

const getDisabledProps = disabled => {
    const ifNotDisabled = runWhen(!disabled);

    return props => ({
        ...props,
        disabled: disabled || (props && props.disabled),
        onClick: ifNotDisabled(props && props.onClick)
    });
};

export const Disableable = ({ children }) => (
    <Consumer>{disabled => children(getDisabledProps(disabled))}</Consumer>
);

export const VisibleWhen = ({ enabled, disabled: whenDisabled, children }) => (
    <Consumer>
        {disabled => {
            const shouldRender = (!disabled && enabled) || (disabled && whenDisabled);
            return shouldRender ? children : undefined;
        }}
    </Consumer>
);
